module.exports = __webpack_public_path__ + "img/background-image.b747860f.png";